import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { GetNotificationsResponse, GetUnreadCountResponse } from './dto';

export class NotificationsApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getNotifications = this.getNotifications.bind(this);
    this.getUnreadCount = this.getUnreadCount.bind(this);
    this.markAsRead = this.markAsRead.bind(this);
    this.markAllAsRead = this.markAllAsRead.bind(this);
    this.deleteNotification = this.deleteNotification.bind(this);
  }

  public async getNotifications(
    page: number = 1,
    pageSize: number = 20,
  ): ApiResult<GetNotificationsResponse> {
    return await this.get<GetNotificationsResponse>(
      `/notifications?page=${page}&pageSize=${pageSize}`,
    );
  }

  public async getUnreadCount(): ApiResult<GetUnreadCountResponse> {
    return await this.get<GetUnreadCountResponse>('/notifications/unread-count');
  }

  public async markAsRead(notificationId: string): ApiResult<{ success: boolean }> {
    return await this.patch<{ success: boolean }>(`/notifications/${notificationId}/read`);
  }

  public async markAllAsRead(): ApiResult<{ success: boolean }> {
    return await this.patch<{ success: boolean }>('/notifications/read-all');
  }

  public async deleteNotification(notificationId: string): ApiResult<{ success: boolean }> {
    return await this.delete<{ success: boolean }>(`/notifications/${notificationId}`);
  }
}

